const Color = {
    BACKGROUND: '#121F36',
    FOREGROUND: '#fcfcfc',
    ACCENT1: "#1F355C",
    ACCENT2: "#2C4B82",
    ACCENT3: "#6D94FF",
    SUCCESS: "#5EB234",
    WARNING: "#E8A530",
    DANGER: "#C91D1D",
    DISABLED: "#c8c8c8",
    HOLIDAY: "#fd9797",
  };

export default Color;
